module.exports = __webpack_public_path__ + "img/experience-bg.e17f3f28.jpg";